import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AreasActions } from './areas.actions';
import { AreaService } from '../../services/area.service';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class AreasEffects {
  private actions$ = inject(Actions);
  private areaService = inject(AreaService);

  loadAreas$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AreasActions.loadAreas),
      switchMap(() =>
        this.areaService.getAll().pipe(
          map(areas => AreasActions.loadAreasSuccess({ areas })),
          catchError(error => of(AreasActions.loadAreasFailure({ error: error.message })))
        )
      )
    )
  );

  createArea$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AreasActions.createArea),
      mergeMap(({ area }) =>
        this.areaService.create(area).pipe(
          map(createdArea => AreasActions.createAreaSuccess({ area: createdArea })),
          catchError(error => of(AreasActions.createAreaFailure({ error: error.message })))
        )
      )
    )
  );

  updateArea$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AreasActions.updateArea),
      mergeMap(({ id, area }) =>
        this.areaService.update(id, area).pipe(
          map(updatedArea => AreasActions.updateAreaSuccess({ area: updatedArea })),
          catchError(error => of(AreasActions.updateAreaFailure({ error: error.message })))
        )
      )
    )
  );

  deleteArea$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AreasActions.deleteArea),
      mergeMap(({ id }) =>
        this.areaService.delete(id).pipe(
          map(() => AreasActions.deleteAreaSuccess({ id })),
          catchError(error => of(AreasActions.deleteAreaFailure({ error: error.message })))
        )
      )
    )
  );
}
